import Typograf from 'typograf';

const copyTypograf = new Typograf({locale: [ 'ru', 'en-US' ]});

export const formatCopy = (text: string): string => copyTypograf.execute(text);

export const formatReferenceCopy = (text: string): string => copyTypograf.execute(text, {
  ruleFilter: rule => ![
    'common/space/delBeforePercent',
    'ru/nbsp/afterNumberSign',
    'common/space/trimLeft',
    'common/space/trimRight',
    'common/space/delTrailingBlanks',
  ].includes(rule.name),
});
